import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography } from "@mui/material"
import { HeaderFiltro } from "../header-filtro"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import AddIcon from '@mui/icons-material/Add'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useListaDeduplicacaoService } from "../../../../../../../use-cases/geo-veles"
import { useEffect, useState } from "react"
import { ListasDeduplicacao } from "./ListasDeduplicacao"
import { PreviaFiltroDeduplicacao } from "./previa-filtro-deduplicacao"

export const FiltroListaDeduplicacao = () => {
    // State
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos)
    const { openListasDeduplicacao } = useAppSelector((state) => state.listaDeduplicacao)
    // Use State
    const [loading, setLoading] = useState<boolean>(true)
    // Hooks
    const { setOpenListasDeduplicacao, setupListaDeduplicacao } = useListaDeduplicacaoService()
    // Use Effect
    useEffect(() => {
        setLoading(false)
    }, [])

    return (
        <>
            {
                loading ? <></>
                    : <>
                        <HeaderFiltro titulo="Listas de Deduplicação"
                            descricao={<>
                                <Typography>
                                    Este filtro permite selecionar listas com CPFs que devem ser <strong>excluídos</strong> da sua busca.
                                </Typography>
                                <Typography
                                    style={{
                                        marginTop: '10px'
                                    }}
                                >
                                    Você pode criar e selecionar quantas listas e CPFs achar necessário.
                                </Typography>
                                <Typography>
                                    Caso nenhuma lista seja selecionada, excluiremos apenas os CPFs já exportados anteriormente neste projeto.
                                </Typography>
                            </>}
                        />

                        <Box my={3} mt={5}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Button
                                        fullWidth
                                        onClick={() => {
                                            setOpenListasDeduplicacao(true)
                                            setupListaDeduplicacao()
                                        }}
                                        endIcon={<AddIcon />}
                                    >
                                        <Typography variant="h6" fontWeight="bold">
                                            Clique para adicionar listas ao projeto
                                        </Typography>
                                    </Button>
                                </Grid>
                                {
                                    (filtrosSelecionados?.listasDeduplicacao?.length ?? 0) > 0 &&
                                    <Grid xs={12}>
                                        <Box p={3} my={3}>
                                            <Accordion defaultExpanded>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    sx={{ display: 'flex', justifyContent: 'center' }}
                                                >
                                                    <Typography
                                                        variant="body1"
                                                        color="primary"
                                                        fontWeight="bold"
                                                        textTransform="uppercase"
                                                        sx={{ textAlign: 'center', width: '100%' }}
                                                    >
                                                        Listas selecionadas
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <PreviaFiltroDeduplicacao />
                                                </AccordionDetails>
                                            </Accordion>
                                        </Box>
                                    </Grid>
                                }
                            </Grid>
                        </Box>

                        <ListasDeduplicacao open={openListasDeduplicacao} />
                    </>
            }
        </>
    )
}